export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/calculator.4a5fc83f.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};